"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProducts = void 0;

var _merchandiseAdapter = _interopRequireDefault(require("self-service-api/adapters/merchandiseAdapter"));

var _noAuthApiClient = _interopRequireDefault(require("hub-http/clients/noAuthApiClient"));

var _q = _interopRequireDefault(require("q"));

var _memoize = _interopRequireDefault(require("../core/utilities/memoize"));

var fetchMerchandise = (0, _memoize.default)(function (_ref) {
  var apiGetter = _ref.apiGetter;

  if (!apiGetter) {
    return _noAuthApiClient.default.get('/monetization-service/v2/merchandise');
  }

  return new _q.default.Promise(function (resolve, reject) {
    apiGetter.whenFinished(function (result) {
      resolve(result);
      window.quickFetch.removeEarlyRequest('merchandise');
    });
    apiGetter.onError(function (err) {
      window.quickFetch.removeEarlyRequest('merchandise');
      return _noAuthApiClient.default.get('/monetization-service/v2/merchandise').then(resolve).catch(function () {
        reject(err);
      });
    });
  });
});

var getProducts = function getProducts() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return fetchMerchandise(opts).then(_merchandiseAdapter.default);
};

exports.getProducts = getProducts;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/api/getProductsNoAuth.js
// module id = 467
// module chunks = 5 6